/* eslint-disable */
import { Calendar, CalendarPropsType, CalendarValueType, CalendarMultipleValueType, CalendarInput, CalendarSelector, ICalendarItem, useDictionary } from '../../shared';
import React from 'react';
import { useIntl } from 'react-intl';
import type { FC } from 'react';
import messages from './messages';
import { CalendarBASF } from '../CalendarBASF';
import { CalendarBASFPropsType } from '../CalendarBASF/types';
import { dictionaryService } from '../../dataFlow';
import { DictionaryItem } from '@sa/rep-mdm';

export const CalendarWeek: FC<CalendarBASFPropsType> = (props => {
  const intl = useIntl();
  const { label, items:itemsProps, dictionary, parameter, disabled } = props;
  const [items, setItems] = React.useState<ICalendarItem[]>();

  const [dictItems] = useDictionary(dictionaryService, itemsProps ? undefined : props.dictionary);
  React.useEffect(() => {
    const itemsSource = (itemsProps || dictItems) as (DictionaryItem[] | null);
    if (itemsSource) {
      const nextItems = itemsSource.map<ICalendarItem>(x => ({
        id: x.id.toString(),
        name: (x.getValue<string | number>("name"))?.toString() || '',
        parent: (x.getValue<string | number>("parent"))?.toString() || '',
        frequency: `${x.getValue<string | number>("frequencyId")}`?.toString() || ''
      }));
      setItems(nextItems);
    }
  }, [dictItems, itemsProps]);
  return (
    <CalendarBASF 
      isDeep 
      disabled={disabled}  
      onChange={props.onChange} 
      value={props.value}
      label={label || intl.formatMessage(messages.title)} 
      items={items} dictionary={dictionary} 
      parameter={parameter} 
      selectorMask={val => val && val.substr(0, 5)} />
  );
});